import { Store } from "redux";
import { DistributorListItem, LoadableThermostat, OJEUThermostat } from "./models";
import {
    ReceiveAllOJEUThermostats,
    ReceiveNewOJEUThermostat,
    RemoveOJEUThermostat,
    UpdateOJEUThermostatState,
    ReceiveLoadableThermostats,
    AddLoadableThermostat,
    UpdateLoadableThermostat,
    RemoveLoadableThermostat,
    ReceiveDistributorSearchResult,
    ReceiveUserSearchResult
} from "./actionTypes";
import { buildHub } from "../../ApiGateway";
import { HubConnectionState } from "@microsoft/signalr";
import { UserAccountItem } from "../UserAccountItem";


// Create OJEU hub
export const OJEUHub = buildHub("OJEUHub");

const mapStringToDate = (t: OJEUThermostat) => {
    if (!!t.mode.holdUntilEndTime && typeof (t.mode.holdUntilEndTime) === "string") {
        t.mode.holdUntilEndTime = new Date(t.mode.holdUntilEndTime);
    }
};

/**
 * Connect to OJEU SignalR hub and register handlers.
 */
export function connectToOJEUHub(store: Store) {
    if (OJEUHub.state !== HubConnectionState.Disconnected) {
        return;
    }

    OJEUHub.start()
        .catch(err => console.error("Failed to start OJEUHub", err));

    OJEUHub.on("ReceiveAllThermostats", (thermostats: OJEUThermostat[]) => {
        thermostats.forEach(mapStringToDate);
        store.dispatch({ type: "RECEIVE_ALL_OJEU_THERMOSTATS", thermostats } as ReceiveAllOJEUThermostats);
    });

    OJEUHub.on("ReceiveNewThermostat", (thermostat: OJEUThermostat) => {
        mapStringToDate(thermostat);
        console.log(thermostat);
        store.dispatch({ type: "RECEIVE_NEW_OJEU_THERMOSTAT", thermostat } as ReceiveNewOJEUThermostat);
    });

    OJEUHub.on("UpdateThermostatState", (thermostat: OJEUThermostat) => {
        mapStringToDate(thermostat);
        store.dispatch({ type: "UPDATE_OJEU_THERMOSTAT_STATE", thermostat } as UpdateOJEUThermostatState);
    });

    OJEUHub.on("RemoveThermostat", (id: string) => {
        store.dispatch({ type: "REMOVE_OJEU_THERMOSTAT", id } as RemoveOJEUThermostat);
    });

    OJEUHub.on("ReceiveLoadableThermostats", (thermostats: LoadableThermostat[]) => {
        store.dispatch({ type: "RECEIVE_LOADABLE_OJEU_THERMOSTATS", thermostats } as ReceiveLoadableThermostats);
    });

    OJEUHub.on("RemoveLoadableThermostat", (id: string) => {
        store.dispatch({ type: "REMOVE_LOADABLE_OJEU_THERMOSTAT", id } as RemoveLoadableThermostat);
    });

    OJEUHub.on("AddLoadableThermostat", (thermostat: LoadableThermostat) => {
        store.dispatch({ type: "ADD_LOADABLE_OJEU_THERMOSTAT", thermostat } as AddLoadableThermostat);
    });

    OJEUHub.on("UpdateLoadableThermostat", (thermostat: LoadableThermostat) => {
        store.dispatch({ type: "UPDATE_LOADABLE_OJEU_THERMOSTAT", thermostat } as UpdateLoadableThermostat);
    });

    OJEUHub.on("ReceiveDistributorSearchResult", (distributors: DistributorListItem[]) => {
        store.dispatch({ type: "RECEIVE_DISTRIBUTOR_SEARCH_RESULT", distributors } as ReceiveDistributorSearchResult);
    });

    OJEUHub.on("ReceiveUserSearchResult", (users: UserAccountItem[]) => {
        store.dispatch({ type: "RECEIVE_USER_SEARCH_RESULT", users } as ReceiveUserSearchResult);
    });
}